import enMessages from '../locales/vi_VI.json';

const ViLang = {
  messages: {
    ...enMessages,
  },
  locale: 'vi-VI',
};
export default ViLang;
